import { Trans, useTranslation } from 'react-i18next'

import { PRIVACY_POLICY_URL } from '@percent/product-nomination-form/constants/privacyPolicyUrl'
import { TERMS_URL } from '@percent/product-nomination-form/constants/termsUrl'
import { ReactComponent as Expand } from '@percent/product-nomination-form/assets/icons/expand.svg'
import {
  Stepper as BaseStepper,
  StepperStep,
  Typography,
} from '@percent/lemonade'
import { Link } from 'react-router-dom'

import styles from './Stepper.module.scss'

export const Stepper = () => {
  const { t } = useTranslation()

  return (
    <BaseStepper
      classNames={{ stepCompletedIcon: styles.stepper }}
      iconSize={32}
      orientation="vertical"
      active={2}
    >
      <StepperStep
        label={
          <Typography className={styles.label} variant="large-bold">
            {t('hostedValidation.stepper.consent')}
          </Typography>
        }
      />
      <StepperStep
        label={
          <Typography className={styles.label} variant="large-bold">
            <Trans
              i18nKey="hostedValidation.stepper.agreeTerms"
              components={{
                a: (
                  <Link
                    className={styles.link}
                    target="_blank"
                    to={TERMS_URL}
                    rel="noopener noreferrer"
                  />
                ),
                1: <Expand />,
              }}
            ></Trans>
          </Typography>
        }
      />
    </BaseStepper>
  )
}
